import styled from '@emotion/styled'

import { mediaUp } from '@/styles/media'
import { spacingSection } from '@/styles/mixins'

export const Container = styled.div`
  ${spacingSection};
  contain: content;
  width: 100%;
`

export const TitleWrapper = styled.div`
  margin-bottom: 40px;
  text-align: center;

  ${mediaUp('lg')} {
    margin-bottom: 80px;
  }
`
